import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/sso-workspace/format'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { getRoute, updateRoute } from './alert-routing-api'
import { useCatalog } from './catalog'
import { ROUTES_PAGE } from './paths'
import { toBody, withTarget } from './route-body'

// "+ Add to a route" on a target's page (owner 2026-10-30: his target existed
// and no route used it): pick a route, and the target becomes one more of its
// actions, switched on, with the type's default message -- the route's own
// GET then PUT (route-body.js), so nothing else about the route changes.
// routes: every route; the ones already sending here aren't offered.
// onAdded(route) after the save.
export const AddToRouteDialog = ({ open, target, routes, onClose, onAdded }) => {
  const catalog = useCatalog()
  const [routeID, setRouteID] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()
  const offered = (routes || []).filter(r => !(r.actions || []).some(a => a.targetID === target.id))

  useEffect(() => {
    if (!open) return
    setError(null)
    setRouteID(offered.length === 1 ? String(offered[0].id) : '')
  }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

  const categoryOf = key => ((catalog.categories || []).find(c => c.key === key) || {}).label || key
  const add = async () => {
    if (busy || !routeID) return
    setBusy(true)
    setError(null)
    try {
      const route = await getRoute(routeID)
      await updateRoute(routeID, toBody(withTarget(route, target.id)))
      onAdded(route)
    } catch (err) {
      setError(serverMessage(err, "The route couldn't be changed."), err)
    } finally {
      setBusy(false)
    }
  }

  return (
    <ConfirmDialog open={open} scrim title="Add to a route" confirmText="Add to route" confirmClassName="btn sw-btn-primary"
      confirmDisabled={!routeID} busy={busy} error={error} failure={failure} onCancel={onClose} onConfirm={add}
      body={offered.length
        ? `The route keeps its other targets and sends to ${target.name} too.`
        : `Every route already sends to ${target.name}, or there are no routes yet.`}>
      {offered.length > 0 &&
        <div className="sw-field mb-3">
          <label className="sw-label" htmlFor="ar-add-route">Route</label>
          <select id="ar-add-route" className="form-select" value={routeID} onChange={e => setRouteID(e.target.value)}>
            <option value="">Pick a route…</option>
            {offered.map(r => <option key={r.id} value={String(r.id)}>{`${r.name} · ${categoryOf(r.category)}`}</option>)}
          </select>
        </div>}
      <p className="sw-hint mb-3">Or <Link to={`${ROUTES_PAGE}/new?target=${encodeURIComponent(target.id)}`}>start a new route with it</Link>.</p>
    </ConfirmDialog>
  )
}
